// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/welcome-frontend/" + {"220":"P6Bx","235":"uurv","380":"yaP1","382":"K_VX","410":"PzS-","450":"mf3M","458":"os6v"}[chunkId] + "-" + {"220":"92f0990adb35","235":"25b188889c8d","380":"8236c0c71362","382":"aeb66efb7049","410":"72265112a458","450":"f2cec12d25d7","458":"2aae51fe867f"}[chunkId] + ".css";
};